module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_frango-frito.d1bc14c0.png";